import React from 'react';
import ReportPageWithMonthWeekSwitch from './components/ReportPageWithMonthWeekSwitch';
import RequestsByWeekListByGame from './components/week/RequestsByWeekListByGame';
import RequestsByMonthListByGame from './components/month/RequestsByMonthListByGame';

function RequestsByGame() {
  return (
    <ReportPageWithMonthWeekSwitch
      title="Requests by game"
      MonthList={RequestsByMonthListByGame}
      WeekList={RequestsByWeekListByGame}
      storageKey="report-group-by"
    />
  );
}

export default RequestsByGame;
